export default __webpack_public_path__ + "static/media/silver_star.23fe0d56.png";